import { MegaMenuPanel } from '@/components/MegaMenu/MegaMenuPanel'
import { MenuContentColumns } from '@/components/MegaMenu/MenuContentColumns'
import { MenuContentPanes } from '@/components/MegaMenu/MenuContentPanes'

import type { FC } from 'react'
import type { TopNavigationNode } from '@/interfaces/NavigationNode'

interface Props {
  navigation: TopNavigationNode[]
}

export const MegaMenuContent: FC<Props> = ({ navigation }) => (
  <>
    {navigation
      .filter((node) => node.children.length > 0)
      .map((node) => (
        <MegaMenuPanel key={node.id} nodeId={node.id}>
          {node.megaMenuLayout === 'panes' ? (
            <MenuContentPanes categories={node.children} />
          ) : (
            <MenuContentColumns node={node} />
          )}
        </MegaMenuPanel>
      ))}
  </>
)
